<template>
  <el-dialog
    class="clockSnapshotDialog"
    :title="title"
    :visible.sync="dialogVisible"
    width="20%"
    @close="closeDialog"
  >
    <div>
      <img
        :src="imgUrl"
        alt="打卡時的照片"
      >
    </div>
    <div slot="footer">
      <el-button
        type="primary"
        round
        @click="clickClose"
      >
        確定
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      title: '',
      dialogVisible: false,
      loading: false,
      imgUrl: ''
    }
  },
  methods: {
    openDialog (url, isClockOutImage = false) {
      this.title = isClockOutImage ? '下班快照' : '上班快照'
      this.imgUrl = url
      this.dialogVisible = true
    },
    clickClose () {
      this.dialogVisible = false
    },
    closeDialog () {
      this.imgUrl = ''
    }
  }
}
</script>
<style lang="sass" scoped>
.clockSnapshotDialog ::v-deep .el-dialog
  +basicDialog
  min-width: 540px
  img
    width: 100%
    background-size: cover
  .el-dialog__footer
    padding-top: 0px
    text-align: center
    border-top: 0
</style>
